import { Deserializable } from '../deserializable';

export class SearchResult implements Deserializable {

  public id: number;
  public registeredName: string;
  public registrationNumber: string;
  public tradingName: string;
  public principalName: string;
  public idNumber: string;
  public passportNumber: string;
  public vatNumber: string;
  public taxNumber: string;
  public industryAlert: true;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
